module.exports = __webpack_public_path__ + "static/media/menu.6b3e722f.svg";